import moment from "moment";
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { getItem, storageKey } from "../../../utilis/methods/storage/storage";
import { useLocation } from "react-router-dom";
import { PatientFullDetailsType } from "../../../PatientCare/PatientBooking/v1/types";
import { EmrContext } from "../../../EMR";
type LoadingType = {
  detailsLoading: boolean;
  Tabloading: boolean;
};
type PatientIdDetails = { encounterId: string; patientMasterId: string };

const initialParams = {
  verificationStatus: 1,
  pageSize: 25,
  pageNo: 0,
  fromDate: moment(new Date()).format("YYYY-MM-DD"),
  toDate: moment(new Date()).format("YYYY-MM-DD"),
  verificationLabel: { id: 1, verificationStatus: "Open" },
}

export type ContextType = {
  searchData: PatientFullDetailsType | null;
  setSearchData: Dispatch<SetStateAction<PatientFullDetailsType | null>>;
  VerificationList: any;
  setVerificationList: (params: any) => void;
  setloading: (
    params: LoadingType | ((param: LoadingType) => LoadingType)
  ) => void;
  loading: LoadingType;
  selectedItem: any;
  setSelectedItem: (params: any) => void;
  listParams: any;
  setListParams: (params: any) => void;
  view: boolean;
  setView: (params: any) => void;
  isDenial: boolean;
  setIsDenial: (params: any) => void;
  patientIdDetails: PatientIdDetails | null;
};
export const verificationContext = createContext<ContextType | null>(null);

export const VerificationProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const [searchData, setSearchData] = useState<PatientFullDetailsType | null>(
    null
  );
  const [VerificationList, setVerificationList] = useState(null);
  const [patientIdDetails, setPatientIdDetails] =
    useState<PatientIdDetails | null>(null);
  const [selectedItem, setSelectedItem] = useState<number | null>(null);
  const [listParams, setListParams] = useState<any>(initialParams);
  const [view, setView] = useState<boolean>(true);
  const [isDenial, setIsDenial] = useState<boolean>(false);
  const [loading, setloading] = useState({
    detailsLoading: false,
    Tabloading: false,
  });
  const { patientData } = useContext(EmrContext);
  const { pathname } = location;
  useEffect(() => {
    const inVerification = pathname.toLowerCase().includes("verification");
    const patientDetails = getItem(storageKey.priorDetailsKey);
    if (Boolean(patientDetails) && !inVerification) {
      setPatientIdDetails(patientDetails);
    } else {
      setPatientIdDetails(null);
      localStorage.removeItem(storageKey.priorDetailsKey);
    }
  }, [pathname]);
  useEffect(() => {
    if (patientData.pmaster.id) {
      setSearchData(patientData);
    }
  }, [patientData]);

useEffect(()=>{
  const paramsData = (localStorage.getItem("verificationParams")) ||JSON.stringify(initialParams)
   setListParams(JSON.parse(String(paramsData)))
},[])

  return (
    <verificationContext.Provider
      value={{
        view,
        setView,
        searchData,
        setSearchData,
        VerificationList,
        setVerificationList,
        selectedItem,
        setSelectedItem,
        loading,
        setloading,
        listParams,
        setListParams,
        isDenial,
        setIsDenial,
        patientIdDetails,
      }}
    >
      {children}
    </verificationContext.Provider>
  );
};
